import { FirebaseError } from 'firebase/app'
// TODO install p-limit
import pLimit from 'p-limit'

const TRANSIENT_ERRORS = new Set([
  'deadline-exceeded',
  'resource-exhausted',
  'unavailable',
])

type Retryable<T> = () => Promise<T>

const delay = (ms: number) => new Promise((resolve) => setTimeout(resolve, ms))

export async function withRetry<T>(
  fn: Retryable<T>,
  {
    attempts = 3,
    baseDelay = 300,
    maxDelay = 2000,
  }: { attempts?: number; baseDelay?: number; maxDelay?: number } = {},
): Promise<T> {
  let tries = 0

  while (true) {
    try {
      return await fn()
    } catch (err) {
      const fbError = err as FirebaseError

      // cuántos reintentos se hacen:
      console.warn(`Retry ${tries} for ${fbError.code}`)

      const transient = fbError?.code && TRANSIENT_ERRORS.has(fbError.code)

      tries += 1
      if (!transient || tries >= attempts) {
        throw err
      }

      const backoff = Math.min(baseDelay * 2 ** (tries - 1), maxDelay)
      await delay(backoff)
    }
  }
}

const limit = pLimit(5) // no más de 5 en paralelo

export const guardedCall = <T>(fn: () => Promise<T>) =>
  limit(() => withRetry(fn))
